import { montserratMedium, montserratNormal, montserratSemibold } from '@/assets/fonts/montserrat'
import { BoltIcon, BriefcaseIcon, ClockIcon } from '@heroicons/react/24/solid'
import { t } from 'i18next'
import React from 'react'
import { useTranslation } from 'react-i18next';

export default function Reasons({ list }) {
  const { t } = useTranslation();

  return (
    <>
      <div className='flex lg:flex-row flex-col text-center lg:text-left justify-between items-center'>
        <p className={`${montserratSemibold.className} text-gray-cool-700 leading-[44px] text-[36px]`}>{t("why_ledgerowl")}</p>
        <p className={`${montserratNormal.className} lg:w-[40rem] lg:leading-[30px] text-gray-cool-500 text-[20px]`}>{t("bookeeping_desc_benefit")}</p>
      </div>
      <ul className='pt-[64px] md:space-y-0 space-y-4 w-full h-full flex md:flex-row flex-col justify-between'>
        {
          list.map((val, index) => (
            <li key={index} className='flex lg:flex-row flex-col'>
              <div className='relative h-[2rem] md:h-[2.5rem] lg:h-full w-[3rem]'>
                <div className='absolute p-[10px] w-10 top-0 flex rounded-full text-blue-primary-500 bg-blue-primary-50'>
                  {val.icon()}
                </div>
              </div>
              <div className='flex pt-4 lg:pt-0 pl-4 reasons-list md:w-[14rem] lg:w-[22rem] relative flex-col'>
                <p className={`${montserratSemibold.className} text-blue-primary-500 text-base`}>{t(val.slug)}</p>
                <p className={`${montserratMedium.className} text-[20px] text-gray-cool-700`}>{t(val.title)}</p>
                <p className={`${montserratNormal.className} pt-2 text-gray-cool-500 text-base`}>{t(val.description)}</p>
              </div>
            </li>
          ))
        }
      </ul>
    </>
  )
}
